import styled from '@emotion/styled';

const FareItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
`;

const FareItemLoading = styled.div`
  width: 80%;
  height: 10px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.11);
`;

export default {
  FareItem,
  FareItemLoading,
};
